import { api } from '@/shared/api';

import type { ActualizeFlightDelayProduct } from './types';

export const actualizeProducts = (
  products: ActualizeFlightDelayProduct[],
  offerId: string,
) =>
  api.client.post(`/products/actualize`, {
    offer_id: offerId,
    products,
  });
